import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const MultirowRoot = styled.tr<{ showRowBorder?: boolean }>(props => ({
    ...(props.showRowBorder && {
        borderTop: theme(props).border.solid,
        ":first-of-type": {
            borderTop: 0,
        },
    }),
}));
